<template>
  <v-row v-if="tab === 2" class="search-section">
    <v-col cols="8" class="search-products-section">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12">
            <v-tooltip top :disabled="!disabled">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <mf-search autofocus class="mx-3" :value="searchValue" :loading="loading" :disabled="disabled" @input="querySelections" />
                </div>
              </template>
              <span>{{ disabledSearchTooltip }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="pb-3" no-gutters>
          <v-col cols="12">
            <span class="pl-3 body-1">Resultados</span>
            <span class="body-1">({{ searchedItems.length }})</span>
          </v-col>
        </v-row>

        <v-row class="scroll-selection" no-gutters>
          <v-col cols="12">
            <div class="modal-div">
              <v-list class="pt-0">
                <v-list-item
                  v-for="(group, index) in productsGroups"
                  :key="`${group.name}-${index}`"
                  class="searched-list"
                  @click="setGroup(group, productsGroups, campaign.offer_sales)"
                >
                  <v-list-item-content>
                    <div>
                      <mf-icon fill color="marca-1"> folder </mf-icon>
                      <span class="body-1 ml-4">{{ group.name }}</span>
                    </div>
                  </v-list-item-content>
                  <v-list-item-action>
                    <mf-icon>chevron_right</mf-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item
                  v-for="(item, searchedIndex) in searchedItems"
                  :key="searchedIndex"
                  class="searched-list"
                  @click="setItem(item, searchedItems, campaign.offer_sales)"
                >
                  <v-list-item-content>
                    <span class="body-1">{{ item.sku }} - {{ item.name }}</span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <mf-icon>chevron_right</mf-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col class="selected-products-section" cols="4">
      <selected-campaign-items
        :searched-items="searchedItems"
        :search-value="searchValue"
        :campaign="campaign"
        :disabled="disabled"
        @set-item="setItem"
        @remove-group="removeGroup"
        @search-item="querySelections"
      />
    </v-col>
  </v-row>
</template>

<script>
import { find, findIndex } from 'lodash'

import SelectedCampaignItems from '@/modules/maria/campanha-da-maria/views/components/SelectedCampaignItems.vue'
import { QUERY_GET_PRODUCTS_AND_GROUPS } from '@/modules/maria/campanha-da-maria/graphql'

export default {
  name: 'FormMariaCampaignTab3',

  components: {
    SelectedCampaignItems,
  },

  props: {
    tab: {
      type: Number,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    searchValue: '',
    loading: false,
    productsGroups: [],
    searchedItems: [],
  }),

  computed: {
    disabledSearchTooltip() {
      return `Não é possível adicionar mais produtos em uma campanha ${this.campaign.status === 'FINISHED' ? 'concluída' : 'ativa'}.`
    },
  },
  methods: {
    querySelections(query) {
      this.searchValue = query
      if (!query || query.length < 3) return
      this.loading = true
      const self = this
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        self.searchItem(query)
      }, 500)
    },

    searchItem(query) {
      const variables = { search: query }
      if (this.onlyActive) {
        variables.active = true
      }
      this.$apollo
        .query({
          query: QUERY_GET_PRODUCTS_AND_GROUPS,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { products: { products } = {}, productsGroups: { productsGroups } } = {} }) => {
          this.productsGroups = this.removeChosenGroups(productsGroups)
          this.searchedItems = this.removeChosenItems(products)
          this.loading = false
        })
    },

    removeChosenGroups(responseData) {
      const array = responseData
      return array.reduce((accumulator, current) => {
        const wasChose = this.campaign.offer_sales.map((product) => product.nameGroup).includes(current.name)

        if (!wasChose) {
          accumulator.push(current)
        }

        return accumulator
      }, [])
    },

    removeChosenItems(responseData) {
      const array = responseData
      for (let item of this.campaign.offer_sales) {
        let itemIndex = array.findIndex((product) => product.sku === item.sku)
        if (itemIndex > -1) {
          array.splice(itemIndex, 1)
        }
      }
      return array
    },

    setGroup(group, removeList, pushList) {
      const itemGroup = find(removeList, {
        _id: group._id,
      })

      if (!itemGroup) return
      const itemGroupIndex = findIndex(removeList, itemGroup)
      const { products, name, ...groupInfo } = removeList[itemGroupIndex]
      const productsFormatted = products.map((product) => ({ isGroup: true, nameGroup: name, groupInfo, ...product }))
      removeList.splice(itemGroupIndex, 1)
      pushList.push(...productsFormatted)
      this.campaign.offer_sales = this.campaign.offer_sales.map((item) => {
        return {
          ...item,
          active: true,
          product: {
            ean: item.ean,
            eans: item.eans,
            sku: item.sku,
          },
        }
      })
    },

    setItem(item, removeList, pushList) {
      const { sku } = item
      const itemObject = find(removeList, {
        sku,
      })
      if (!itemObject) return
      const itemObjectIndex = findIndex(removeList, itemObject)
      removeList.splice(itemObjectIndex, 1)
      if (!itemObject.isGroup) pushList.sort((a, b) => this.sortList(a, b)).push(itemObject)
      this.campaign.offer_sales = this.campaign.offer_sales.map((item) => {
        return {
          ...item,
          product: {
            ean: item.ean,
            eans: item.eans,
            sku: item.sku,
          },
        }
      })
    },

    sortList(a, b) {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    },

    removeGroup(group, removeList, pushList) {
      this.productsGroups.push(group)
      group.products.forEach((product) => {
        this.setItem(product, removeList, pushList)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-products-section {
  border-left: 1px solid$cinza-l60;
  overflow-y: auto;
  overflow-x: none;
  max-height: 600px;
}

.search-section {
  margin: 0px 0px;
  margin-top: -20px;
}

.search-products-section {
  overflow-y: auto;
  overflow-x: none;
  max-height: 600px;

  .scroll-selection {
    overflow: auto;
    padding: 0 12px;
  }
  .modal-div {
    border-radius: 5px;
    overflow-y: auto;
  }
  .dark-background {
    background-color: $cinza-l90;
  }
  .searched-list {
    background-color: #f3f3f3 !important;
    border-top: 1px solid $cinza-l70;
  }
}
</style>
